<div class="fixActionRow">
    <mat-dialog-content>
        <div class="p-grid" fxLayout="column">
            <h2 mat-dialog-title>Report Dashboard</h2>
            <form [formGroup]="formGroup" novalidate fxLayout="column">
                <mat-tab-group fxFlex="1 1 auto">
                    <mat-tab label="Configuration" fxFlex="1 1 auto" fxLayout="column">
                        <div fxLayout="column">
                            <mat-form-field>
                                <input matInput readonly placeholder="Identifier" name="identifier"
                                    formControlName="identifier">
                            </mat-form-field>
                            <mat-form-field>
                                <input matInput required placeholder="Name" name="name" formControlName="name"
                                    maxlength="64">
                            </mat-form-field>
                            <mat-form-field>
                                <input matInput required placeholder="Title" name="title" formControlName="title"
                                    maxlength="128">
                            </mat-form-field>
                        </div>
                    </mat-tab>
                    <mat-tab label="Running & Distribution" fxFlex="1 1 auto" fxLayout="column">
                        <div fxLayout="column">
                            <div fxLayout="row">
                                <mat-form-field fxFlex="1 1 35%">
                                    <mat-label>Schedule</mat-label>
                                    <mat-select formControlName="schedule">
                                        <mat-option *ngFor="let scheduleType of scheduleTypes"
                                            [value]="scheduleType.value">
                                            {{scheduleType.label}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div fxLayout="row">
                                <p fxFlex="0 0 auto" fxLayout="column" fxLayoutGap="0.5em" fxFlex="1 1 35%">
                                    <mat-label>Email Format</mat-label>
                                    <mat-button-toggle-group fxFlex="0 0 auto" color="primary" appearance="legacy"
                                        formControlName="emailFormat">
                                        <mat-button-toggle class="configuration-toggle-button" value="NONE">None
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="HTML">HTML
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="PDF">PDF
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="XLSX">XLSX
                                        </mat-button-toggle>
                                    </mat-button-toggle-group>
                                </p>
                            </div>
                            <mat-checkbox formControlName="autoPublish">Auto Publish</mat-checkbox>
                            <mat-form-field>
                                <mat-chip-list #emailChipList formControlName="emailRecipients">
                                    <mat-chip
                                        *ngFor="let emailRecipient of reportDashboardConfig.publishingConfig.emailRecipients"
                                        [selectable]="false" [removable]="true" (removed)="removeEmail(emailRecipient)">
                                        {{emailRecipient}}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip>
                                    <input placeholder="Email Recipients..." [matChipInputFor]="emailChipList"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addEmail($event)">
                                </mat-chip-list>
                            </mat-form-field>
                        </div>
                    </mat-tab>
                    <mat-tab label="Permissions" fxFlex="1 1 auto" fxLayout="column">
                        <app-report-dashboard-permission #permission [designers]="designers"
                            [reportDashboardPersistedConfig]="reportDashboardConfig"
                            (formReady)="addFormControl('permissions', $event)">
                        </app-report-dashboard-permission>
                    </mat-tab>
                    <mat-tab *ngIf="license?.dashboard?.customLayouts === true" label="Layout" fxFlex="1 1 auto"
                        fxLayout="column">
                        <mat-button-toggle-group fxFlex="0 0 auto" color="primary" appearance="legacy"
                            formControlName="layoutMode">
                            <mat-button-toggle class="configuration-toggle-button" value="AUTOMATIC">Automatic
                            </mat-button-toggle>
                            <mat-button-toggle class="configuration-toggle-button" value="CUSTOM">Custom
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                        <app-dashboard-layout-builder #builder [fxHide]="layoutMode.value !=='CUSTOM'"
                            [reportDashboardConfig]="reportDashboardConfig">
                        </app-dashboard-layout-builder>
                    </mat-tab>
                </mat-tab-group>
            </form>
        </div>
    </mat-dialog-content>
    <div class="spacer"></div>
    <mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]>Cancel</button>
        <button mat-button [mat-dialog-close]="reportDashboardConfig" color="primary" [disabled]="!formGroup.valid"
            (click)="onOKButton()">Ok</button>

    </mat-dialog-actions>
</div>